import {
  Address,
  AddressForm,
  AddressResponseData,
  AddressTypes,
  AssetFormData,
  BaseAddress,
  DigitalAddress,
  EmailAddressForm,
  ErrorType,
  FormValidation,
  GetAddresses,
  QuickAddress,
  QuickAddresses,
  QuickAddressesResponse,
  QuickAddressResponse,
  QuickAddressSubmitData,
  RecipientResponseData,
  SaveAddressResponse,
  UpdateAddress,
} from './addresses';
import {
  AddToCartParams,
  AddToCartResponse,
  CartData,
  LineItemAdded,
  MiniCart,
  MockCartUtility,
  ProductLineItem,
  RecentBasket,
  RequestBody,
} from './basket';
import {
  Breakpoints,
  CanvasJson,
  CustomFabricImage,
  CustomFabricObject,
  EditCanvasJson,
  FabricObject,
  FabricTextBox,
  ObjectJson,
  OmitMethods,
} from './canvas';
import { CardType } from './card';
import {
  CardDimensions,
  CardEditableArea,
  CardFace,
  CardFaceData,
  CardFacePreviewImage,
  CardText,
  EditableTextSettings,
  EditableZoneSettings,
} from './card-face';
import { GetProjectAsset, GetProjectResponseData, ProjectAssetData } from './digital-greetings';
import { ConfirmProjectDetailsRequestBody, DigitalOrderRequestBody } from './digital-orders';
import { EditableArea } from './editable-area';
import { Envelope, EnvelopePreviewBody, EnvelopePreviewResponse, SelectedEnvelope } from './envelope';
import { Font, OpenTypeFont } from './font';
import { AccountProfileResponse, FulfillmentResponse, PreviewFormData, PreviewResponseData } from './fulfillment';
import {
  cleanUpFormData,
  CleanUpImageResponse,
  cropAndRotateFormData,
  CropAndRotateResponse,
  ImageResponse,
  linkPhotoFormData,
  LinkPhotoResponse,
  PreviewAssetType,
  PreviewLabel,
} from './images';
import { InformationDetails } from './information-details';
import { InitBody, InitializationData, ProjectAsset, ProjectTypeCode, TemplateData } from './initialization-data';
import { CustomerAuthResponseData, HallmarkMembershipStatus } from './membership';
import { Layer, Page, PageItem } from './page';
import { PhotoTextZoneConfig, PhotoTextZoneDefaultSettings, PhotoTextZoneSettings } from './photo-text-zone';
import { PhotoZone } from './photo-zone';
import { RegionalCodesList } from './regions-list';
import { DEFAULT_PROJECT_NAMES } from './save-project';
import {
  ApiResponse,
  ErrorResponse,
  ErrorResponseData,
  GetPreviewProps,
  Meta,
  SuccessNoContentResponse,
} from './services';
import { MappedSpellcheckSuggestion, SpellcheckActions, SpellcheckErrors, SpellcheckSuggestion } from './spellcheck';
import { TextZone } from './text-zone';
import { CommonProperties } from './utility';

declare global {
  interface Window {
    fabric: any;
    _satellite?: any;
  }
}

window.fabric = window.fabric || {};

export type {
  Envelope,
  SelectedEnvelope,
  Page,
  PageItem,
  Layer,
  Font,
  OpenTypeFont,
  PhotoZone,
  TextZone,
  EditableArea,
  InitializationData,
  InformationDetails,
  CardFace,
  CardDimensions,
  CardEditableArea,
  CardFacePreviewImage,
  CardFaceData,
  CardText,
  EditableTextSettings,
  EditableZoneSettings,
  ImageResponse,
  LinkPhotoResponse,
  SaveAddressResponse,
  BaseAddress,
  Address,
  DigitalAddress,
  FormValidation,
  AddressForm,
  EmailAddressForm,
  AddressResponseData,
  FulfillmentResponse,
  PreviewResponseData,
  PreviewFormData,
  AccountProfileResponse,
  ProjectAssetData,
  GetProjectAsset,
  GetProjectResponseData,
  EnvelopePreviewResponse,
  EnvelopePreviewBody,
  MiniCart,
  ProductLineItem,
  QuickAddress,
  QuickAddressResponse,
  QuickAddressesResponse,
  CleanUpImageResponse,
  CropAndRotateResponse,
  linkPhotoFormData,
  cleanUpFormData,
  cropAndRotateFormData,
  QuickAddressSubmitData,
  TemplateData,
  CartData,
  RequestBody,
  AddToCartResponse,
  RecentBasket,
  AddToCartParams,
  MockCartUtility,
  GetAddresses,
  UpdateAddress,
  LineItemAdded,
  ProjectTypeCode,
  QuickAddresses,
  ApiResponse,
  ErrorResponse,
  ErrorResponseData,
  GetPreviewProps,
  Meta,
  InitBody,
  ProjectAsset,
  SuccessNoContentResponse,
  CanvasJson,
  EditCanvasJson,
  FabricObject,
  ObjectJson,
  OmitMethods,
  Breakpoints,
  FabricTextBox,
  CustomFabricObject,
  CustomFabricImage,
  CommonProperties,
  AssetFormData,
  RecipientResponseData,
  DigitalOrderRequestBody,
  ConfirmProjectDetailsRequestBody,
  PhotoTextZoneConfig,
  PhotoTextZoneDefaultSettings,
  PhotoTextZoneSettings,
  SpellcheckErrors,
  SpellcheckSuggestion,
  MappedSpellcheckSuggestion,
  CustomerAuthResponseData,
  HallmarkMembershipStatus,
};

export {
  CardType,
  ErrorType,
  AddressTypes,
  DEFAULT_PROJECT_NAMES,
  RegionalCodesList,
  PreviewAssetType,
  PreviewLabel,
  SpellcheckActions,
};
